// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3k61V","label":"Completed_label__38KY6"};